// Search Events
export const SEARCH = 'search';

// PLP/SRP Events
export const VIEW_ITEM_LIST = 'view_item_list';
export const SELECT_ITEM = 'select_item';

// PDP Events
export const VIEW_ITEM = 'view_item';
export const ADD_TO_CART = 'add_to_cart';

// Cart Page Events
export const VIEW_CART = 'view_cart';
export const REMOVE_FROM_CART = 'remove_from_cart';
export const CART_UPDATED = 'cart_updated';
export const BEGIN_CHECKOUT = 'begin_checkout';

// Checkout Events
export const ADD_SHIPPING_INFO = 'add_shipping_info';
export const ADD_PAYMENT_INFO = 'add_payment_info';
export const ADD_ADDRESS_INFO = 'add_address_info';

// Thank You Page Events
export const PURCHASE = 'purchase';

// User Auth Events
export const LOGIN = 'login';
export const SIGN_UP = 'sign_up';
export const LOGOUT = 'account_logout';

// Account Order History Events (Custom)
export const VIEW_ORDER_LIST = 'view_order_list';
export const VIEW_ORDER_DETAILS = 'view_order_details';

// Account Events
export const ACCOUNT_CREATED = 'account_created';
export const ACCOUNT_VERIFIED = 'account_verified';
export const ACCOUNT_DETAILS_UPDATED = 'account_details_updated';

// Coupon Events
export const COUPON_APPLIED = 'coupon_applied';
export const COUPON_FAILED = 'coupon_failed';
export const COUPON_REMOVED = 'coupon_removed';

export const INVOICE_DOWNLOADED = 'invoice_downloaded';

export const PASSWORD_CHANGED = 'password_changed';

export const ERROR_404 = '404';

export const CLICK = 'click';

// Button IDs for tracking
// NOTE: These IDs are temporal.
// Ideally, they will be configurable for every component in a CMS.
export const BUTTON_IDS = {
  ADVERTISEMENT: 'advertisement',
  HEADER_NAVIGATION_DESKTOP: 'header-navigation-desktop',
  MOBILE_MENU: 'mobile-menu',
} as const;

// Wizard
export const START_WIZARD = 'start_wizard';
export const WIZARD_STEP_VIEWED = 'wizard_step_viewed';
export const WIZARD_STEP_COMPLETED = 'wizard_step_completed';
